/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import { ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';

/**
 * GetCmsListContent Input Action
 */
export class GetCmsListContentInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CMS_LIST_CONTENT`;
    public getCacheObjectType = () => 'CMS_LIST_CONTENT';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCmsListContentData {
    totalItem: any;
    dataCms: AttributeValue[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCmsListContentInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCmsListContentInput, ctx: Msdyn365.IActionContext): Promise<IGetCmsListContentData | null> {
    let pageID: string = '';
    let pathName: string = '';
    let searchParam: string = '';
    const userID: string | undefined = ctx.requestContext.user.customerAccountNumber;
    if (ctx && ctx.requestContext && ctx.requestContext.url && ctx.requestContext.url.requestUrl) {
        pathName = ctx.requestContext.url.requestUrl.pathname;
        const pieces = pathName.split(/[\s\/]+/);
        pageID = pieces[pieces.length - 1];
        searchParam = ctx.requestContext.url.requestUrl.searchParams.toString();
        if (ObjectExtensions.isNullOrUndefined(searchParam) || searchParam === '') {
            searchParam = `?user-id=${userID}`;
        } else {
            searchParam = `?${searchParam}&user-id=${userID}`;
        }
    }
    if (pageID !== '') {
        const frontApiEndpoint = ctx.requestContext.app.config.cmsAPIEndpoint && ctx.requestContext.app.config.cmsAPIEndpoint;
        const requestUrl = `${frontApiEndpoint}/api/list/node--${pageID}/en${searchParam}`;

        const result = await Msdyn365.sendRequest<IGetCmsListContentData>(requestUrl, 'get')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                ctx.trace('[GetCmsListContent] Failed to get list cms.');
                throw error;
            });
        return result;
    }

    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCmsListContentData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCmsListContent',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
